/**
 * Defines the columns
 * And any action against the columns
 */
import { ColDef } from 'ag-grid-community';

export class ProductsColumnsModel {
	private _columns: Array<ColDef>;
	constructor() {
		this._columns = [
			{
				headerName: 'Title',
				field: 'title',
				width: 230
			},
			{
				headerName: 'Origin',
				field: 'origin',
				width: 90
			},
			{
				headerName: 'Active',
				field: 'active',
				width: 70
			},
			{
				headerName: 'AppScope Job Name',
				field: 'appScopeJobName',
				width: 120
			},
			{
				headerName: 'Acuity Product Name',
				field: 'acuityProductName',
				width: 110
			},
			{
				headerName: 'Nexsys Product Name',
				field: 'nexsysProductName',
				width: 110
			},
			{
				headerName: 'Valutrust',
				field: 'valutrustProductName',
				width: 110

			},
			{
				headerName: 'Software Collector',
				field: 'softwareCollector',
				width: 110
			},
			{
				headerName: 'Package Name',
				field: 'insideMapsTitle',
				width: 110
			},
			{
				headerName: 'Inspection Schema',
				field: 'inspectionSchema',
				width: 110
			},
			{
				headerName: 'Actions',
				width: 70,
				cellRenderer: 'customActionProductsCellComponent'
			}
		];
	}

	get columns(): Array<any> {
		return this._columns;
	}
}
